// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"09604bb9","854":"1498f68e"}[chunkId] + ".chunk.js";
};